/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Hero_Cta_SecondaryInputs */

const en_dr_hero_cta_secondary = /** @type {(inputs: Dr_Hero_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how it works`)
};

const id_dr_hero_cta_secondary = /** @type {(inputs: Dr_Hero_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat cara kerja`)
};

/**
* | output |
* | --- |
* | "See how it works" |
*
* @param {Dr_Hero_Cta_SecondaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_hero_cta_secondary = /** @type {((inputs?: Dr_Hero_Cta_SecondaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Hero_Cta_SecondaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_hero_cta_secondary(inputs)
	return en_dr_hero_cta_secondary(inputs)
});